import { FC } from "react";
import { ICalendarLesson } from "../../../../entities/calendar";
import { CALENDAR_DAY_SLOT_HEIGHT_PX } from "../../../../shared/lib/const/calendarDay";
import { LongArrowLeftIcon, StudentIcon, TutorIcon } from "../../../../shared/ui/icon";
import { getLessonTransferLabel } from "../../lib/lessonTransfer";
import classes from '../calendarDay.module.scss'

interface IProps {
    lesson: ICalendarLesson;
    startIndex: number;
    endIndex: number;
    left: number;
    width: number;
    zIndex: number;
    visibleStartsAt: Date;
    visibleEndsAt: Date;
    formatTime: (date: Date) => string;
    statusClassName: string;
    onSelect: (lesson: ICalendarLesson) => void;
}

export const CalendarDayLessonBlock: FC<IProps> = ({
    lesson, startIndex, endIndex, left, width, zIndex, visibleStartsAt, visibleEndsAt,
    formatTime, statusClassName, onSelect,
}) => {
    const lessonTagName = typeof lesson.tag === 'string'
        ? (lesson.tag || 'Без тега')
        : (lesson.tag?.name || 'Без тега')
    const transferLabel = getLessonTransferLabel(lesson)
    
    return (
        <button
            type="button"
            className={`${classes.lesson} ${statusClassName}`}
            style={{
                top: startIndex * CALENDAR_DAY_SLOT_HEIGHT_PX,
                height: Math.max(
                    (endIndex - startIndex) * CALENDAR_DAY_SLOT_HEIGHT_PX - 2,
                    CALENDAR_DAY_SLOT_HEIGHT_PX - 2
                ),
                left,
                width,
                maxWidth: `calc(100% - ${left}px)`,
                zIndex,
            }}
            title={
                `${formatTime(visibleStartsAt)}–${formatTime(visibleEndsAt)} · ` +
                `${lesson.student.fullName} · ${lessonTagName}` +
                (transferLabel ? ` · ${transferLabel.text}` : '')
            }
            onPointerDown={event => event.stopPropagation()}
            onClick={() => onSelect(lesson)}
        >
            <section className={classes.lessonHeader}>
                <strong className={classes.studentName}>
                    <StudentIcon size={15} />
                    {lesson.student.fullName}
                </strong>
                <span className={classes.lessonTime}>
                    {formatTime(visibleStartsAt)}–{formatTime(visibleEndsAt)}
                </span>
            </section>
            <span className={classes.lessonDetails}>
                <TutorIcon size={14} />
                <span>{lesson.tutor.fullName}</span>
                <span className={classes.lessonSubject}>{lessonTagName}</span>
            </span>
            {transferLabel && (
                <span className={
                    classes.lessonTransfer +
                    (transferLabel.isMovedFrom ? ` ${classes.lessonTransferFrom}` : '')
                }>
                    <LongArrowLeftIcon
                        size={14}
                        className={transferLabel.isMovedFrom ? undefined : classes.lessonTransferArrowTo}
                    />
                    {transferLabel.text}
                </span>
            )}
        </button>
    )
}
